import type { IntlShape } from "@formatjs/intl";
import { Form, Select, type SelectProps } from "antd";
import { type DefaultOptionType } from "antd/es/cascader";
import { type Rule } from "antd/es/form";
import { type FilterFunc } from "rc-select/lib/Select";
import React, { useMemo } from "react";
import { getUserDisplayName } from "../../../common/utils/userDisplayName";
import { type UserLimitedList } from "../../generated-axios-client";

const createdBySelectOptions = (userItems: UserLimitedList[]) => {
  const createdByOptions = userItems.map((item) => ({
    key: item.id,
    value: item.id,
    label: getUserDisplayName(item),
  }));

  return createdByOptions;
};

const createdBySearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
  const search = input.toLowerCase();
  const value = option?.label?.toString().toLowerCase?.() ?? "";

  return value.includes(search);
};

type CreatedBySelectFormItemProps = {
  intl: IntlShape;
  userItems: UserLimitedList[];
  rules?: Rule[];
  placeholder?: string | boolean;
  selectProps?: SelectProps<string>;
};

export const CreatedBySelectorFormItem = (props: CreatedBySelectFormItemProps) => {
  const { intl, userItems, rules = [], placeholder = false, selectProps } = props;

  const options = useMemo(() => createdBySelectOptions(userItems), [userItems]);

  return (
    <Form.Item
      name="created_by"
      label={intl.formatMessage({ id: "filter_label_created_by" })}
      rules={rules}
    >
      <Select
        placeholder={placeholder}
        showSearch={true}
        options={options}
        filterOption={createdBySearchHandler}
        {...selectProps}
      />
    </Form.Item>
  );
};
